<template>
<div class="pa-3 full-width">
    <div class="chart-heading mb-2 ml-1">{{chart.name}}</div> 
    <div class="date-section">
        <div v-for="(transaction, n) in todaysTransactions" class="shadow date-card" :key="'today'+n">
            <ImageGroup :images="clientImages(transaction.clients)" :size="70" style="margin-top:-20px;" />
            <div class="heading">{{clientNames(transaction.clients)}}</div>
            <div class="heading" style="color:#666">{{transaction.title}}</div>
            <div class="date-bar" :style="{'background-color' : transaction.color}"></div>
        </div>
    </div>
    <NoRecordsPlaceholder v-if="!todaysTransactions.length">
        Nothing today!
    </NoRecordsPlaceholder>
    
    <div class="chart-heading mt-2 mb-2 ml-1">Tomorrow</div> 
    <div class="date-section">
        <div v-for="(transaction, m) in tomorrowsTransactions" class="shadow date-card" :key="'today'+ m">
            <ImageGroup :images="clientImages(transaction.clients)" :size="70" style="margin-top:-20px;" />
            <div class="heading">{{clientNames(transaction.clients)}}</div>
            <div class="heading" style="color:#666">{{transaction.title}}</div>
            <div class="date-bar" :style="{'background-color' : transaction.color}"></div>
        </div>
    </div>
    <NoRecordsPlaceholder v-if="!tomorrowsTransactions.length">
        Nothing tomorrow!
    </NoRecordsPlaceholder>    
</div>
</template>

<script>
import Utilities from '../../helpers/Utilities'
import DataHelpers from '../../helpers/DataHelpers'
import ContactHelpers from '../../helpers/ContactHelpers'
import NiceData from '../../data/NiceData'
import ChartControl from './ChartControl'
import DateHelpers from '../../helpers/DateHelpers'
import ImageGroup from '../../ui-elements/ImageGroup'
import NoRecordsPlaceholder from '../../ui-elements/NoRecordsPlaceholder'

// import { format } from 'date-fns'
export default {
name: 'UpcomingChart',
props: {
    tenantKey: String,
    chart: Object
},
components: {
    ImageGroup, NoRecordsPlaceholder,
},

data() {
return {
    transactions: {}
}
},
computed:{
    combinedTransactions() {
        let combinedTransactions = []
        for(let prop in this.transactions) {
            console.log('prop:' + prop)
            combinedTransactions = [...combinedTransactions, ...this.transactions[prop]]
        }
        return combinedTransactions || 'hello   '
    },

    todaysTransactions() {
        return this.combinedTransactions.filter(o => o.date == DateHelpers.todayString())
    },
    tomorrowsTransactions() {
        return this.combinedTransactions.filter(o => o.date == DateHelpers.tomorrowString())
    }

},
methods: {
    transactionLink(transactionKey) {
        return '/' + this.tenantKey + '/transaction/' + transactionKey
    },

    clientImages(clientsObj) {
        const clients = Utilities.objectToObjectArray(clientsObj)
        const images = clients.map(o => o.image)
        return images
    },
    clientNames(clientsObj) {
        const clients = Utilities.objectToObjectArray(clientsObj)
        const names = ContactHelpers.combineClientsNames(clients) 
        return names
    },
},
created() {

    // set up listeners for each field...

    let n = 0
    this.chart.dates.forEach(dateField => {
        const ref = DataHelpers.getTenantRef(this.tenantKey).child('milestones')
            .orderByChild(dateField.name).startAt(DateHelpers.yesterdayString()).endAt(DateHelpers.tomorrowString())   
        ref.on('value', snap => {   
            const item = NiceData.arrayFromSnapshot(snap).map(o => {
                
                return {
                    clients: o.clients,
                    date: o[dateField.name],
                    title: dateField.title,
                    color: dateField.color,
                }
            })
            this.$set(this.transactions, dateField.name, item)
        })
        n++
    }); 
    
   
}
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>  

    .date-section {
        display:flex;flex-wrap:wrap;background-color:#f0f0f0;padding:15px;border-radius:7px
    }
    .date-card {
        border-radius:7px;width:350px; height:150px;margin:8px;margin-top:22px;text-align:center;background-color:white;    
    }
    .date-bar {
        height:4px;width:300px;margin:10px auto;border-radius:3px;
    }
    .chart-outline {
        min-width:100%;
        margin-top:-35px;
    }
    .chart-header {
        width:100%;font-weight: bold; padding:10px;
        color:#888; height:35px;
    }
    .chart-row {
        width:100%;
    }
    .chart-column {
        padding:1px; flex-grow: 1;
    }
    .chart-cell {
        /* background-color: #eee; */
        height:60px;
    }
    .chart-heading {
        font-size:28px;
        color:rgb(5, 116, 150);
    }

</style>


// WEBPACK FOOTER //
// UpcomingChart.vue?50dc7156